import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=46c5f20e"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"
import style0 from "./Frame.vue?vue&type=style&index=0&id=46c5f20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports